<template>
  <svg viewBox="0 0 16 16">
    <path
      d="M7.273,10.909H8.727v1.455H7.273ZM8,3.636A2.929,2.929,0,0,0,5.091,6.545H6.545a1.455,1.455,0,0,1,2.909,0c0,1.455-2.182,1.273-2.182,3.636H8.727c0-1.636,2.182-1.818,2.182-3.636A2.929,2.929,0,0,0,8,3.636ZM16,8a8,8,0,1,0-8,8A8.012,8.012,0,0,0,16,8ZM15,8A7,7,0,1,1,8,1,7,7,0,0,1,15,8Z"
      fill="#0072ff"
      class="Icon-help-path"
    />
  </svg>
</template>
